export const IOPEmails: string[] = [
  'prathyusha.karnagolla@cbre.com',
  'venkateswara.sharma@cbre.com',
  'naveen.muppaneni@cbre.com',
  'g.pratap@cbre.com',
  'dineshbabu.ganapathi@cbre.com',
  'vinaygupta.kancharla@cbre.com',
  'ch.chandishwar@cbre.com',
  'varun.kumar2@cbre.co.in',
  'vinay.mohadikar@cbre.com',
  'gangireddy.suuda@cbre.com',
  'swarajtanaya.panda@cbre.com',
  'suresh.arrathoti@cbre.com',
  'amireddy.mounika@cbre.com',
  'gubbala.kumar@cbre.com',
  'aditya.vinjamoori@cbre.com',
  'raichur.sowmyarani@cbre.com',
  'nandini.vemuganti@cbre.com',
  'someshwarreddy.dasari@cbre.com',
  'pravallikarani.chingaodaba@cbre.com',
  'nagavinodkumar.nelavalli@cbre.com',
  'karthik.kallapalli@cbre.com',
  'sneha.priyadarshni@cbre.com',
  'neha.meena@cbre.com',
  'dineshbabu.ganapathi@cbre.com',
  'karreddi.prathyusha@cbre.com',
  'devanjan.nanda1@cbre.com',
  'sarpitha.reddy@cbre.com',
  'putchakayala.saisruthi@cbre.com',
  'songa.keerthi@cbre.com',
  'nallakunta.bhavya@cbre.com',
  'mucharla.indusai@cbre.com',
  'kadimetla.akhila@cbre.com',
  'shri.darshiniss@cbre.com',
  'kunapulishkumarakrishna.saipraneeth@cbre.com',
  'komati.vineetha@cbre.com',
  'kalyan.kandagatla@cbre.com',
  'apurva.jha@cbre.com',
  'shreya.upreti@cbre.com',
  'shipra.gupta@cbre.com',
  'sunaina.garg@cbre.com',
  'disha.arya@cbre.com',
  'pavan.bonasi@cbre.com',
  'gottam.bhagyalakshmi@cbre.com',
  'pavani.maddu@cbre.com',
  'saivivek.panchagiri@cbre.com',
  'mohdsayeeduddin.ahmed@cbre.com',
  'rakesh.chandra@cbre.com',
  'suryanarayanasairam.desaraju@cbre.com',
  'saimohanreddy.duvuri@cbre.com',
  'saiteja.aakula@cbre.com',
  'vijaykumarreddy.bosigari@cbre.com',
  'vamshibhargav.kandi@cbre.com',
  'katyayani.singh@cbre.com',
  'sandeepkumar.miryala@cbre.com',
];
